import { useTranslation } from 'react-i18next';
import { Icon } from '../header/draft/Icon';
import '../settings/delete-account-modal.css';

type SocialDuplicateEmailModalProps = {
  email: unknown;
  social: unknown;
  onCancel: () => void;
  onContinue: () => void;
};

function capitalizePlatform(label: string): string {
  const normalized = label.trim();
  if (!normalized) return '';
  return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
}

/** API options.socials — string | string[] | 기타 */
export function formatSocialLabel(social: unknown): string {
  if (social == null) return '—';
  if (Array.isArray(social)) {
    const parts = social.map((item) => formatSocialLabel(item)).filter((item) => item !== '—');
    return parts.length > 0 ? parts.join(', ') : '—';
  }
  const text = String(social).trim();
  if (!text || text === '[object Object]') return '—';
  return capitalizePlatform(text);
}

function formatEmailLabel(email: unknown): string {
  if (email == null) return '—';
  const text = String(email).trim();
  return text || '—';
}

export function SocialDuplicateEmailModal({
  email,
  social,
  onCancel,
  onContinue,
}: SocialDuplicateEmailModalProps) {
  const { t } = useTranslation();

  return (
    <div className="delete-account-modal" role="alertdialog" aria-labelledby="social-duplicate-email-modal-title">
      <div className="delete-account-modal__icon-wrap delete-account-modal__icon-wrap--info">
        <Icon name="mail" className="delete-account-modal__icon" />
      </div>

      <h2 id="social-duplicate-email-modal-title" className="delete-account-modal__title">
        {t('loginSignupAlert.duplicateEmailTitle')}
      </h2>

      <p className="delete-account-modal__description">{t('loginSignupAlert.duplicateEmailDescription')}</p>

      <div className="delete-account-modal__details">
        <div className="delete-account-modal__detail-row">
          <span className="delete-account-modal__detail-label">{t('loginSignupAlert.duplicateEmailLabel')}</span>
          <span className="delete-account-modal__detail-value">{formatEmailLabel(email)}</span>
        </div>
        <div className="delete-account-modal__detail-row">
          <span className="delete-account-modal__detail-label">{t('loginSignupAlert.duplicateSocialLabel')}</span>
          <span className="delete-account-modal__detail-value">{formatSocialLabel(social)}</span>
        </div>
      </div>

      <div className="delete-account-modal__actions">
        <button type="button" className="delete-account-modal__btn delete-account-modal__btn--cancel" onClick={onCancel}>
          {t('loginSignupAlert.duplicateEmailCancel')}
        </button>
        <button type="button" className="delete-account-modal__btn delete-account-modal__btn--primary" onClick={onContinue}>
          {t('loginSignupAlert.duplicateEmailContinue')}
        </button>
      </div>
    </div>
  );
}
